import { deliveryInfo, deliveryTag } from './pricing';
// Données géo-optimisées pour les pages "location glace italienne + ville"
// Chaque ville a du contenu unique : introduction, événements locaux, quartiers, FAQ, avis Google.

const buildFaqs = (city) => [
  {
    q: `Combien coûte la location d'une machine à glace italienne à ${city}?`,
    a: `Nos tarifs sont publics et transparents : 200 € TTC la location machine + kits consommables à 58 € l'unité (2 bidons de 5 litres + 100 cornets ou pots = 100 glaces par kit). Vous ajustez la quantité exacte selon votre nombre d'invités à ${city}. Livraison et installation incluses dans un rayon de 30 km autour de Quimper.`,
  },
  {
    q: `Livrez-vous vraiment à ${city} sans frais supplémentaires ?`,
    a: `Oui, la livraison, l'installation et la mise en route sont incluses dans un rayon de 30 km autour de Quimper. Au-delà, seulement 0,70 €/km — un tarif très compétitif. Contactez-nous pour la simulation exacte selon votre adresse à ${city}.`,
  },
  {
    q: `Quels parfums de glace italienne à ${city} ?`,
    a: `Notre machine professionnelle propose 3 parfums au choix : fraise, vanille, chocolat. Vous choisissez à la réservation. Idéal pour un mariage, un anniversaire ou une kermesse à ${city}.`,
  },
  {
    q: `Puis-je réserver longtemps à l'avance pour un événement à ${city} ?`,
    a: `Absolument. Nous acceptons les réservations jusqu'à 12 mois à l'avance. Les samedis d'été (juin-août) et les vendredis-samedis de septembre sont très demandés à ${city} et environs. Un acompte de 30 % bloque votre date. Report gratuit dans les 12 mois en cas de mauvais temps.`,
  },
  {
    q: `Proposez-vous une animation en plus de la machine à ${city} ?`,
    a: `Oui — c'est notre grande force. Nous pouvons ajouter une mascotte (Mickey, Stitch, Pat Patrouille…), un clown magicien ou un spectacle enfants pour animer votre événement à ${city}. Un combo unique en Bretagne : machine + animation le même jour, par le même prestataire.`,
  },
];

export const GLACE_CITIES = {
  quimper: {
    name: 'Quimper',
    slug: 'quimper',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '0 km (basé sur place)',
    deliveryInfo: deliveryInfo(0),
    deliveryTag: deliveryTag(0),
    reviewCount: 50,
    introExtra: `Basé à Quimper même, Le Clown Magicien intervient dans tous les quartiers en 15 minutes maximum. Livraison strictement gratuite à Quimper.`,
    localEventsIntro: `Quimper accueille chaque année de nombreux événements où la glace italienne fait fureur : mariages en centre-ville, fêtes de quartier, festivals culturels.`,
    localEvents: [
      { title: 'Festival de Cornouaille (juillet)', desc: 'Notre machine trouve sa place dans les stands du festival, offrant un rafraîchissement gourmand aux festivaliers.' },
      { title: 'Mariages à Locmaria & Kerfeunteun', desc: 'Vin d\'honneur en terrasse, garden party : la glace italienne est parfaite en juin, juillet et août.' },
      { title: 'Kermesses écoles (Ergué-Armel, Penhars…)', desc: 'Les écoles quimpéroises nous sollicitent chaque année pour animer leurs fêtes de fin d\'année.' },
    ],
    zones: ['Centre-ville', 'Locmaria', 'Kerfeunteun', 'Ergué-Armel', 'Penhars', 'Pluguffan', 'Briec', 'Rosporden', 'Plomelin', 'Combrit', 'Pont-l\'Abbé'],
    faqs: buildFaqs('Quimper'),
    reviews: [
      { author: 'Sophie M.', date: '2025-07-18', body: 'Machine à glace italienne parfaite pour notre mariage à Quimper. Livraison à l\'heure, machine impeccable, invités ravis !' },
      { author: 'Julien P.', date: '2025-08-22', body: 'Loué pour l\'anniversaire de ma fille à Ergué-Armel. Le clown magicien et la machine à glace ont fait un carton.' },
    ],
  },
  brest: {
    name: 'Brest',
    slug: 'brest',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '70 km',
    deliveryInfo: deliveryInfo(70),
    deliveryTag: deliveryTag(70),
    reviewCount: 48,
    introExtra: `Nous intervenons à Brest et sa métropole (Guipavas, Plouzané, Le Relecq-Kerhuon) avec une livraison à 0,70 €/km au-delà de 30 km de Quimper.`,
    localEventsIntro: `Brest est une ville d'événements majeurs — Fêtes Maritimes, arbres de Noël d'entreprises (Naval Group, Crédit Mutuel…) — où la glace italienne apporte une touche gourmande.`,
    localEvents: [
      { title: 'Fêtes Maritimes de Brest', desc: 'Tous les 4 ans, la ville accueille l\'un des plus gros rassemblements nautiques d\'Europe. Nos machines équipent stands et esplanades.' },
      { title: 'Arbres de Noël CSE Brest', desc: 'Grosses entreprises brestoises, hôpitaux, mutuelles : combinez notre spectacle magie/Père Noël avec un stand glace pour les enfants.' },
      { title: 'Mariages Saint-Marc, Bellevue, Kerinou', desc: 'Notre machine à glace italienne est adaptée aux mariages dans les salles polyvalentes de la métropole brestoise.' },
    ],
    zones: ['Centre-ville Brest', 'Saint-Marc', 'Lambezellec', 'Bellevue', 'Kerinou', 'Recouvrance', 'Guipavas', 'Plouzané', 'Le Relecq-Kerhuon', 'Plougastel-Daoulas'],
    faqs: buildFaqs('Brest'),
    reviews: [
      { author: 'Marc L.', date: '2025-08-14', body: 'Excellent rapport qualité-prix. Machine propre et performante pour notre vin d\'honneur à Brest. Je recommande !' },
      { author: 'Élise D.', date: '2025-06-30', body: 'Machine à glace italienne parfaite pour la kermesse de l\'école de Guipavas. Tarif transparent, livraison OK.' },
    ],
  },
  lorient: {
    name: 'Lorient',
    slug: 'lorient',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '65 km',
    deliveryInfo: deliveryInfo(65),
    deliveryTag: deliveryTag(65),
    reviewCount: 38,
    introExtra: `Lorient et son agglomération (Lanester, Ploemeur, Hennebont) sont couverts depuis notre base à Quimper (0,70 €/km au-delà de 30 km).`,
    localEventsIntro: `Lorient vibre au rythme du Festival Interceltique, mais aussi des mariages en bord de rade et des événements d'entreprise. La glace italienne s'y invite naturellement.`,
    localEvents: [
      { title: 'Festival Interceltique (août)', desc: 'Notre machine intervient sur des stands officiels et parallèles au festival, très demandée pendant les 10 jours de folie celtique.' },
      { title: 'Mariages Larmor-Plage, Ploemeur', desc: 'Vin d\'honneur en bord de mer : la glace italienne est le rafraîchissement idéal pour un mariage estival.' },
      { title: 'Événements Sub Base', desc: 'Anciens abris à sous-marins reconvertis : nos machines équipent les événements d\'entreprise et cocktails privés.' },
    ],
    zones: ['Centre-ville Lorient', 'Lanester', 'Hennebont', 'Ploemeur', 'Guidel', 'Larmor-Plage', 'Quéven', 'Caudan', 'Inzinzac-Lochrist', 'Languidic'],
    faqs: buildFaqs('Lorient'),
    reviews: [
      { author: 'Thomas B.', date: '2025-08-05', body: 'Loué pour un mariage à Larmor-Plage. Machine impeccable, les invités se sont régalés au vin d\'honneur.' },
      { author: 'Anne-Laure V.', date: '2025-07-11', body: 'Super machine à glace italienne pour l\'anniversaire de mes enfants à Lanester. Les parfums vanille et chocolat, ils ne s\'en lassaient pas !' },
    ],
  },
  vannes: {
    name: 'Vannes',
    slug: 'vannes',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '110 km',
    deliveryInfo: deliveryInfo(110),
    deliveryTag: deliveryTag(110),
    reviewCount: 32,
    introExtra: `Nous intervenons dans tout Vannes et le Golfe du Morbihan avec une livraison à 0,70 €/km au-delà de 30 km de Quimper. Réservation conseillée 4 semaines à l'avance en haute saison.`,
    localEventsIntro: `Vannes et le Golfe du Morbihan sont des destinations de mariage estivales très prisées. La glace italienne est le must-have des vins d'honneur en bord de golfe.`,
    localEvents: [
      { title: 'Mariages Golfe du Morbihan', desc: 'Arradon, Sarzeau, Île-aux-Moines, Île-d\'Arz : nos machines équipent les mariages les plus prestigieux du golfe.' },
      { title: 'Fête de la Musique / Fêtes historiques', desc: 'Vannes célèbre son patrimoine avec de nombreux événements culturels — la glace italienne y a toute sa place.' },
      { title: 'Auray, Carnac, Quiberon', desc: 'Zones balnéaires estivales : nos machines interviennent pour campings, hôtels et fêtes privées.' },
    ],
    zones: ['Centre-ville Vannes', 'Séné', 'Arradon', 'Ploeren', 'Theix-Noyalo', 'Elven', 'Saint-Avé', 'Plescop', 'Auray', 'Carnac', 'Sarzeau'],
    faqs: buildFaqs('Vannes'),
    reviews: [
      { author: 'Camille R.', date: '2025-06-15', body: 'Machine à glace italienne parfaite pour notre mariage à Arradon. Vue sur le Golfe et glace onctueuse : combo gagnant !' },
      { author: 'Guillaume F.', date: '2025-08-30', body: 'Loué pour un événement d\'entreprise à Vannes. Professionnalisme au top, tarif clair, RAS.' },
    ],
  },
  concarneau: {
    name: 'Concarneau',
    slug: 'concarneau',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '25 km',
    deliveryInfo: deliveryInfo(25),
    deliveryTag: deliveryTag(25),
    reviewCount: 28,
    introExtra: `Concarneau est à 25 km de Quimper. Livraison gratuite (moins de 30 km) pour vos événements en Ville Close, à Trégunc ou Pont-Aven.`,
    localEventsIntro: `Concarneau, avec sa Ville Close et ses plages, est une destination phare pour mariages, kermesses et festivals estivaux.`,
    localEvents: [
      { title: 'Fêtes Bleues de Concarneau (août)', desc: 'Marins, folklore, festivités : les stands gourmands avec machine à glace font le bonheur des visiteurs.' },
      { title: 'Mariages Ville Close', desc: 'Le charme incomparable de la Ville Close attire les mariés — la glace italienne s\'y accorde parfaitement.' },
      { title: 'Kermesses Trégunc & Pont-Aven', desc: 'Écoles, associations, comités des fêtes : nous équipons régulièrement les événements locaux.' },
    ],
    zones: ['Centre-ville Concarneau', 'Ville Close', 'Rosporden', 'Melgven', 'Elliant', 'Névez', 'Trégunc', 'Pont-Aven', 'Fouesnant', 'Beg-Meil'],
    faqs: buildFaqs('Concarneau'),
    reviews: [
      { author: 'Marine C.', date: '2025-07-25', body: 'Location de la machine à glace italienne pour notre mariage à Trégunc. Impeccable, tarif transparent, service pro !' },
    ],
  },
  fouesnant: {
    name: 'Fouesnant',
    slug: 'fouesnant',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '18 km',
    deliveryInfo: deliveryInfo(18),
    deliveryTag: deliveryTag(18),
    reviewCount: 22,
    introExtra: `Fouesnant est à 18 km de Quimper — livraison strictement gratuite. Zone estivale majeure (Beg-Meil, Mousterlin, La Forêt-Fouesnant).`,
    localEventsIntro: `Fouesnant et ses plages (Beg-Meil, Mousterlin) sont des lieux de villégiature estivale par excellence — mariages, événements de plage et campings s'y multiplient.`,
    localEvents: [
      { title: 'Mariages Beg-Meil & Mousterlin', desc: 'Vin d\'honneur en bord de plage : la glace italienne est parfaite en juillet-août.' },
      { title: 'Événements campings', desc: 'Nombreux campings sur la côte : location saisonnière de machines pour animations quotidiennes.' },
      { title: 'La Forêt-Fouesnant', desc: 'Salle du Nautile, base nautique : nos machines équipent événements et fêtes privées.' },
    ],
    zones: ['Fouesnant centre', 'Beg-Meil', 'Mousterlin', 'La Forêt-Fouesnant', 'Bénodet', 'Pleuven', 'Saint-Évarzec', 'Clohars-Fouesnant'],
    faqs: buildFaqs('Fouesnant'),
    reviews: [
      { author: 'Anne P.', date: '2025-08-10', body: 'Loué pour notre mariage à Beg-Meil. Machine parfaite, glaces excellentes, tout le monde était ravi.' },
    ],
  },
  morlaix: {
    name: 'Morlaix',
    slug: 'morlaix',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '75 km',
    deliveryInfo: deliveryInfo(75),
    deliveryTag: deliveryTag(75),
    reviewCount: 20,
    introExtra: `Nous intervenons à Morlaix et dans toute la Baie (Carantec, Roscoff, Saint-Pol-de-Léon, Plouescat) avec une livraison à 0,70 €/km au-delà de 30 km de Quimper.`,
    localEventsIntro: `Morlaix, ville d'art et d'histoire, accueille de nombreux événements — mariages en centre-ville historique, fêtes de la Baie, kermesses.`,
    localEvents: [
      { title: 'Fêtes maritimes Roscoff-Carantec', desc: 'La Baie de Morlaix célèbre son patrimoine maritime — nos machines équipent stands et esplanades.' },
      { title: 'Mariages centre historique Morlaix', desc: 'Salles de réception, viaduc, port : décors uniques et glace italienne au vin d\'honneur.' },
      { title: 'Kermesses Baie de Morlaix', desc: 'Écoles et associations de Saint-Pol-de-Léon, Carantec, Plouigneau, Plougonven.' },
    ],
    zones: ['Morlaix centre', 'Saint-Martin-des-Champs', 'Plouigneau', 'Plougonven', 'Lanmeur', 'Carantec', 'Saint-Pol-de-Léon', 'Roscoff', 'Plouescat'],
    faqs: buildFaqs('Morlaix'),
    reviews: [
      { author: 'Yannick M.', date: '2025-07-02', body: 'Machine à glace italienne parfaite pour la fête de l\'école à Saint-Pol-de-Léon. Enfants ravis !' },
    ],
  },
  benodet: {
    name: 'Bénodet',
    slug: 'benodet',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '15 km',
    deliveryInfo: deliveryInfo(15),
    deliveryTag: deliveryTag(15),
    reviewCount: 18,
    introExtra: `Bénodet est à 15 km de Quimper — livraison strictement gratuite. Ville balnéaire prisée avec Sainte-Marine et Combrit.`,
    localEventsIntro: `Bénodet, station balnéaire du Pays Bigouden, est réputée pour ses mariages en bord de mer et ses événements estivaux au bord de l'Odet.`,
    localEvents: [
      { title: 'Mariages front de mer Bénodet', desc: 'Casino, hôtels front de mer, port : décors idylliques et vin d\'honneur avec glace italienne.' },
      { title: 'Sainte-Marine & Combrit', desc: 'Port pittoresque et salles de réception recherchés pour mariages et événements privés.' },
      { title: 'Événements estivaux Odet', desc: 'Croisières, bases nautiques, restaurants front de mer : nos machines animent aussi les événements corporate.' },
    ],
    zones: ['Bénodet centre', 'Sainte-Marine', 'Combrit', 'Pleuven', 'Le Perguet', 'Clohars-Fouesnant', 'Pont-l\'Abbé'],
    faqs: buildFaqs('Bénodet'),
    reviews: [
      { author: 'Nathalie R.', date: '2025-08-18', body: 'Loué pour notre mariage à Bénodet. Machine top, service impeccable. On recommande à nos amis !' },
    ],
  },
  douarnenez: {
    name: 'Douarnenez',
    slug: 'douarnenez',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '25 km',
    deliveryInfo: deliveryInfo(25),
    deliveryTag: deliveryTag(25),
    reviewCount: 12,
    introExtra: `Douarnenez, cité maritime du Pays Bigouden, à 25 min de Quimper. Livraison gratuite (moins de 30 km). Nous connaissons parfaitement les salles de Tréboul, du Port-Rhu et de Ploaré.`,
    localEventsIntro: `Douarnenez vibre au rythme de ses festivals maritimes et de ses événements de bord de mer, terrain de jeu idéal pour la glace italienne.`,
    localEvents: [
      { title: 'Festival de cinéma Douarnenez', desc: 'Événement culturel majeur en août : brunchs, cocktails, réceptions — parfait pour un stand glace italienne.' },
      { title: 'Fêtes maritimes Temps Fête', desc: 'Toutes les bi-annuelles, ce grand rassemblement de vieux gréements attire des milliers de visiteurs assoiffés de fraîcheur.' },
      { title: 'Mariages Tréboul & Port-Rhu', desc: 'Salles avec vue sur la baie de Douarnenez, ambiance marine unique, parfaite pour un pack mariage.' },
    ],
    zones: ['Douarnenez centre', 'Tréboul', 'Port-Rhu', 'Ploaré', 'Poullan-sur-Mer', 'Le Juch', 'Kerlaz'],
    faqs: buildFaqs('Douarnenez'),
    reviews: [
      { author: 'Yann K.', date: '2025-07-25', body: 'Location impec pour l\'anniversaire à Tréboul. Livraison à l\'heure, machine ultra propre. Merci !' },
    ],
  },
  'pont-l-abbe': {
    name: "Pont-l'Abbé",
    slug: 'pont-l-abbe',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '22 km',
    deliveryInfo: deliveryInfo(22),
    deliveryTag: deliveryTag(22),
    reviewCount: 9,
    introExtra: `Pont-l'Abbé, capitale du Pays Bigouden, à 22 km de Quimper. Livraison gratuite (moins de 30 km). Nous connaissons parfaitement les salles municipales, les Halles et les campings des communes bigoudènes environnantes.`,
    localEventsIntro: `Pont-l'Abbé, cœur historique du Pays Bigouden, est réputé pour la Fête des Brodeuses et ses mariages traditionnels — occasions idéales pour un stand glace italienne artisanale.`,
    localEvents: [
      { title: 'Fête des Brodeuses (juillet)', desc: 'Grand rendez-vous folklorique bigouden : défilés, danses, ambiance festive — parfait pour un stand glace en centre-ville.' },
      { title: 'Mariages Pays Bigouden', desc: 'Salles des Arcs, chapelle de Tronoën, hôtels et manoirs : notre machine glace italienne rafraîchit vin d\'honneur et brunchs.' },
      { title: 'Kermesses Loctudy, Penmarch, Le Guilvinec', desc: 'Écoles publiques et privées du Pays Bigouden : nos machines animent les APE tout au long de l\'année scolaire.' },
    ],
    zones: ["Pont-l'Abbé centre", 'Halles', 'Loctudy', 'Penmarch', 'Le Guilvinec', 'Plobannalec-Lesconil', 'Combrit', "Île-Tudy"],
    faqs: buildFaqs("Pont-l'Abbé"),
    reviews: [
      { author: 'Sophie L.', date: '2025-07-14', body: 'Machine louée pour la Fête des Brodeuses — un carton total ! Damien super réactif, à recommander sans hésiter.' },
    ],
  },
  quimperle: {
    name: 'Quimperlé',
    slug: 'quimperle',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '45 km',
    deliveryInfo: deliveryInfo(45),
    deliveryTag: deliveryTag(45),
    reviewCount: 10,
    introExtra: `Quimperlé, ville confluence à 45 min de Quimper. Livraison à 0,70 €/km au-delà de 30 km (soit 10,50 €). Nous intervenons dans toute la basse et haute ville.`,
    localEventsIntro: `Quimperlé, ville d'art et d'histoire, accueille mariages, festivals et événements corporate autour de l'Isole et de l'Ellé.`,
    localEvents: [
      { title: 'Mariages Basse-Ville historique', desc: 'Abbaye Sainte-Croix, prieuré, hôtels de charme : cadres uniques pour un vin d\'honneur avec glace italienne.' },
      { title: 'Festival Rias de septembre', desc: 'Festival d\'arts de rue majeur — nos machines animent afters, brunchs et espaces VIP.' },
      { title: 'Événements corporate Cléguer & Rédéné', desc: 'Zones d\'activité économique dynamiques : arbres de Noël CSE et journées team-building.' },
    ],
    zones: ['Quimperlé centre', 'Basse-Ville', 'Haute-Ville', 'Cléguer', 'Rédéné', 'Baye', 'Mellac', 'Le Trévoux'],
    faqs: buildFaqs('Quimperlé'),
    reviews: [
      { author: 'Sophie L.', date: '2025-06-14', body: 'Mariage à l\'Abbaye Sainte-Croix, machine à glace un franc succès. Nos invités en parlent encore.' },
    ],
  },
  chateaulin: {
    name: 'Châteaulin',
    slug: 'chateaulin',
    dept: 'Finistère',
    code: '29',
    geoRegion: 'FR-29',
    distanceQuimper: '30 km',
    deliveryInfo: deliveryInfo(30),
    deliveryTag: deliveryTag(30),
    reviewCount: 9,
    introExtra: `Châteaulin, sous-préfecture au bord de l'Aulne, à 30 min de Quimper. Livraison gratuite (30 km). Idéal pour couvrir aussi Pleyben, Cast et le Ménez-Hom.`,
    localEventsIntro: `Châteaulin est un carrefour événementiel du Finistère central, entre Aulne et Ménez-Hom, où mariages et fêtes de village jalonnent l'année.`,
    localEvents: [
      { title: 'Mariages bord de l\'Aulne', desc: 'Salles au bord de la rivière, quai des Ducs, cadres reposants pour un vin d\'honneur estival.' },
      { title: 'Grand Prix cycliste de Châteaulin', desc: 'Événement historique de fin août : stands, animations, buvettes — idéal pour une glace italienne en plein air.' },
      { title: 'Fêtes de Pleyben & Cast', desc: 'Fêtes de village du Menez-Hom, kermesses paroissiales, événements associatifs : notre zone naturelle.' },
    ],
    zones: ['Châteaulin centre', 'Port-Launay', 'Pleyben', 'Cast', 'Saint-Coulitz', 'Saint-Ségal', 'Dinéault'],
    faqs: buildFaqs('Châteaulin'),
    reviews: [
      { author: 'Erwan B.', date: '2025-08-02', body: 'Loué pour la kermesse de Pleyben, machine parfaite, 200 glaces distribuées en 2h.' },
    ],
  },
  auray: {
    name: 'Auray',
    slug: 'auray',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '90 km',
    deliveryInfo: deliveryInfo(90),
    deliveryTag: deliveryTag(90),
    reviewCount: 11,
    introExtra: `Auray, ville d'histoire au bord de la rivière, cœur du Golfe du Morbihan. Nous intervenons à Auray et dans les communes environnantes (Saint-Goustan, Carnac, presqu'île de Quiberon).`,
    localEventsIntro: `Auray et sa région (Carnac, Quiberon, Étel) accueillent d'innombrables mariages et événements estivaux, la glace italienne y fait toujours sensation.`,
    localEvents: [
      { title: 'Mariages Saint-Goustan & Golfe', desc: 'Quartier historique de Saint-Goustan, salles avec vue sur le Loch — cadres uniques.' },
      { title: 'Kermesses & fêtes de Carnac-Quiberon', desc: 'Stations balnéaires ultra fréquentées l\'été, événements associatifs et professionnels toute la saison.' },
      { title: 'Festival Photo la Gacilly (satellite)', desc: 'Événement culturel majeur, expositions au bord des menhirs et sites patrimoniaux.' },
    ],
    zones: ['Auray centre', 'Saint-Goustan', 'Carnac', 'Quiberon', 'Étel', 'Locmariaquer', 'Pluvigner', 'Belz'],
    faqs: buildFaqs('Auray'),
    reviews: [
      { author: 'Fabienne T.', date: '2025-07-20', body: 'Location pour un mariage à Carnac, machine impec, invités enchantés. Merci !' },
    ],
  },
  hennebont: {
    name: 'Hennebont',
    slug: 'hennebont',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '75 km',
    deliveryInfo: deliveryInfo(75),
    deliveryTag: deliveryTag(75),
    reviewCount: 8,
    introExtra: `Hennebont, cité médiévale au bord du Blavet, entre Lorient et Auray. Nous couvrons aussi Lanester, Kervignac et toute la vallée du Blavet.`,
    localEventsIntro: `Hennebont, ville d'art et d'histoire, accueille chaque année des événements culturels et corporate — le Haras National est un lieu emblématique de mariage.`,
    localEvents: [
      { title: 'Mariages au Haras National', desc: 'Site prestigieux du Haras, salles de réception classées — parfait pour un pack mariage premium.' },
      { title: 'Fêtes médiévales des Remparts', desc: 'Grand rassemblement historique bi-annuel, animations pour tout public — un festival glace italienne idéal.' },
      { title: 'Événements corporate Lanester-Kervignac', desc: 'Zones d\'activité économique, arbres de Noël CSE et team-building.' },
    ],
    zones: ['Hennebont centre', 'Basilique', 'Lanester', 'Kervignac', 'Merlevenez', 'Inzinzac-Lochrist', 'Pluvigner'],
    faqs: buildFaqs('Hennebont'),
    reviews: [
      { author: 'Julien M.', date: '2025-06-08', body: 'Machine louée pour un événement au Haras d\'Hennebont. Nickel de A à Z !' },
    ],
  },
  lanester: {
    name: 'Lanester',
    slug: 'lanester',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '70 km',
    deliveryInfo: deliveryInfo(70),
    deliveryTag: deliveryTag(70),
    reviewCount: 7,
    introExtra: `Lanester, seconde ville de l'agglomération lorientaise. Zone dense en entreprises (Naval Group, DCNS) et en événements associatifs.`,
    localEventsIntro: `Lanester est un pôle économique majeur du Morbihan, où arbres de Noël CSE, kermesses d'écoles et événements familiaux animent l'année.`,
    localEvents: [
      { title: 'Arbres de Noël CSE Naval Group', desc: 'Grandes entreprises maritimes de la rade — événements CSE hivernaux à haute fréquentation.' },
      { title: 'Kermesses d\'écoles Lanester', desc: 'Nombreuses écoles primaires et maternelles, fêtes de fin d\'année scolaire animées.' },
      { title: 'Fêtes de quartiers du Plessis', desc: 'Événements de proximité, animations sociales et communales très demandées.' },
    ],
    zones: ['Lanester centre', 'Le Plessis', 'Kesler-Devillers', 'Kerentrech', 'Ker-Anna', 'Caudan', 'Riantec'],
    faqs: buildFaqs('Lanester'),
    reviews: [
      { author: 'Anaïs P.', date: '2025-06-14', body: 'Loué pour l\'arbre de Noël du CSE. Machine + animations, un franc succès !' },
    ],
  },
  pontivy: {
    name: 'Pontivy',
    slug: 'pontivy',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '95 km',
    deliveryInfo: deliveryInfo(95),
    deliveryTag: deliveryTag(95),
    reviewCount: 6,
    introExtra: `Pontivy, sous-préfecture au cœur du Morbihan, ville jumelle Napoléonienne. Nous couvrons Baud, Cléguérec, Rohan, et toute la vallée du Blavet.`,
    localEventsIntro: `Pontivy est un pôle central du Morbihan intérieur — mariages, événements agricoles, fêtes de villages abondent tout l'été.`,
    localEvents: [
      { title: 'Foire de Pontivy', desc: 'Grande foire commerciale et agricole, événement historique majeur — stands glace italienne appréciés.' },
      { title: 'Mariages vallée du Blavet', desc: 'Domaines et propriétés en pierre — cadres bucoliques recherchés pour mariages en Bretagne intérieure.' },
      { title: 'Fêtes des villages Rohan-Cléguérec', desc: 'Fêtes de printemps et d\'été très animées, animations gourmandes très demandées.' },
    ],
    zones: ['Pontivy centre', 'Napoléonville', 'Baud', 'Cléguérec', 'Rohan', 'Le Sourn', 'Neulliac'],
    faqs: buildFaqs('Pontivy'),
    reviews: [
      { author: 'Louis G.', date: '2025-07-12', body: 'Loué pour un mariage à Baud, tout parfait, malgré la distance livraison très correcte.' },
    ],
  },
  guingamp: {
    name: 'Guingamp',
    slug: 'guingamp',
    dept: 'Côtes-d\'Armor',
    code: '22',
    geoRegion: 'FR-22',
    distanceQuimper: '105 km',
    deliveryInfo: deliveryInfo(105),
    deliveryTag: deliveryTag(105),
    reviewCount: 5,
    introExtra: `Guingamp, sous-préfecture des Côtes-d'Armor, terre de football et d'histoire. Nous intervenons aussi à Bégard, Belle-Isle-en-Terre et toute la vallée du Trieux.`,
    localEventsIntro: `Guingamp est un pôle événementiel des Côtes-d'Armor : Festival de la Saint-Loup, événements sportifs et fêtes populaires y sont légion.`,
    localEvents: [
      { title: 'Festival de la Saint-Loup', desc: 'Grand festival de danse et culture bretonne fin août — public familial, stand glace italienne parfaite fraîcheur.' },
      { title: 'Événements EA Guingamp', desc: 'Stade Roudourou, animations d\'avant-match et fêtes du club — idéal pour animations gourmandes.' },
      { title: 'Fêtes de Bégard & Belle-Isle', desc: 'Bourgs actifs, kermesses et fêtes communales très demandées l\'été.' },
    ],
    zones: ['Guingamp centre', 'Pabu', 'Ploumagoar', 'Bégard', 'Belle-Isle-en-Terre', 'Bourbriac', 'Squiffiec'],
    faqs: buildFaqs('Guingamp'),
    reviews: [
      { author: 'Marc D.', date: '2025-07-30', body: 'Livraison à Bégard, machine impeccable, très pro. Je recommande.' },
    ],
  },
  ploermel: {
    name: 'Ploërmel',
    slug: 'ploermel',
    dept: 'Morbihan',
    code: '56',
    geoRegion: 'FR-56',
    distanceQuimper: '130 km',
    deliveryInfo: deliveryInfo(130),
    deliveryTag: deliveryTag(130),
    reviewCount: 5,
    introExtra: `Ploërmel, capitale de la Bretagne intérieure orientale, au bord du lac au Duc. Nous couvrons Josselin, Malestroit, La Trinité-Porhoët, Guer et le Morbihan intérieur.`,
    localEventsIntro: `Ploërmel est un pôle stratégique de l'est Morbihan — événements corporate, mariages en châteaux et fêtes médiévales sont son quotidien.`,
    localEvents: [
      { title: 'Mariages Château de Josselin', desc: 'Site classé UNESCO, cadre exceptionnel pour mariages haut de gamme — pack mariage sur mesure.' },
      { title: 'Fêtes médiévales de Josselin', desc: 'Grand rassemblement médiéval bi-annuel, public familial nombreux — animation glace italienne idéale.' },
      { title: 'Événements corporate Ploërmel', desc: 'Zones d\'activité dynamiques (Yves Rocher, LDC), arbres de Noël CSE haut de gamme.' },
    ],
    zones: ['Ploërmel centre', 'Josselin', 'Malestroit', 'La Trinité-Porhoët', 'Guer', 'Campénéac', 'Loyat'],
    faqs: buildFaqs('Ploërmel'),
    reviews: [
      { author: 'Corentin V.', date: '2025-08-01', body: 'Mariage au Château de Josselin, machine glace italienne — un moment magique pour nos invités !' },
    ],
  },
};
